import {
    CATEGORY_DATA,
    COMPANY_DATA, BLOG_LIST_DATA,
    MENU_LIST_DATA,
    SEO_META_DATA,
    WEBSITE_CONTENT, WEBSITE_LOADING
} from "../constant";
const initialState = {
    seoMetaData:[],
    websiteContentData:[],
    menuListData:false,
    companyData:false,
    blogListData:false,
    company_id:process.env.COMPANY_ID ?? 10,
    websiteLoading:true
}
export  const webSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEO_META_DATA:
            return { ...state, seoMetaData: action.payload };
        case WEBSITE_CONTENT:
            return { ...state, websiteContentData: action.payload };
        case MENU_LIST_DATA:
            return { ...state, menuListData: action.payload };
        case COMPANY_DATA:
            return { ...state, companyData: action.payload };
        case CATEGORY_DATA:
            return { ...state, categoryListData: action.payload };
        case BLOG_LIST_DATA:
            return { ...state, blogListData: action.payload };
        case WEBSITE_LOADING:
            return { ...state, websiteLoading: action.payload };
        default:
            return state
    }
}
